import { render, staticRenderFns } from "./JcdcLoadingPage.vue?vue&type=template&id=1d3d365b"
import script from "./JcdcLoadingPage.vue?vue&type=script&lang=ts"
export * from "./JcdcLoadingPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports